/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEye: {
  name: 'eye';
  data: string;
} = {
  name: 'eye',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 17c-2.8 0-5.992-1.63-7.87-5C6.009 8.63 9.2 7 12 7s5.992 1.63 7.87 5c-1.878 3.37-5.07 5-7.87 5Zm0-12c-3.567 0-7.43 2.062-9.643 6.074a1.917 1.917 0 0 0 0 1.852C4.571 16.938 8.433 19 12 19c3.567 0 7.43-2.062 9.643-6.074a1.917 1.917 0 0 0 0-1.852C19.429 7.062 15.567 5 12 5Zm-1 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" fill="currentColor"/></svg>`,
};
